import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import { extractColors, formatHttpsUrl } from '@utils/utils';
import { BrandingCardStyles } from './BrandingCard.styled';

const getClassName = (branding) => {
  switch (branding.contentfulName.toLowerCase()) {
    case 'logos':
      return 'gtm-brand-logos';

    case 'brand guidelines':
      return 'gtm-brand-guidelines';

    default:
      return 'gtm-' + branding.contentfulName.toLowerCase().replace(' ', '-');
  }
};

const BrandingCard = ({ branding }) => {
  const brandingImageUrl =
    (branding &&
      branding?.brandingImage &&
      formatHttpsUrl(branding.brandingImage.url + '?h=250&fm=webp')) ||
    '';
  const brandingImageAltText =
    (branding && branding?.brandingImage && branding.brandingImage.altText) ||
    branding?.brandingName;

  return (
    <BrandingCardStyles
      $backgroundColor={extractColors(branding.brandingBackgroundColor)}
    >
      <a
        href={branding.url}
        className={getClassName(branding)}
        target="_blank"
        rel="noreferrer"
      >
        <div className="branding-media">
          <Image alt={brandingImageAltText} src={brandingImageUrl} fill />
        </div>
        <div className="branding-details">
          <h3>{branding.brandingName}</h3>
          <span className="standard">{branding.brandingDescription}</span>
        </div>
      </a>
    </BrandingCardStyles>
  );
};

BrandingCard.propTypes = {
  branding: PropTypes.shape({
    brandingBackgroundColor: PropTypes.any,
    brandingDescription: PropTypes.any,
    brandingImage: PropTypes.shape({
      altText: PropTypes.any,
      url: PropTypes.string,
    }),
    brandingName: PropTypes.any,
    url: PropTypes.any,
  }),
};

export default BrandingCard;
